module.exports = __webpack_public_path__ + "static/media/landing-1-shape.76191018.svg";